var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s((this.loading || this.record?.loading ? ' ' : (_vm.count || '0'))))])
}
var staticRenderFns = []

export { render, staticRenderFns }